export default __webpack_public_path__ + "assets/courier-overview-video-1-thumbnail-new.png";